const code = `# [netflix-email-forwarder](https://github.com/chiazo/netflix-email-forwarder)

${"A solution to me never being on my phone when my family on the west coast needs the netflix code!"}

----
# [big-two](https://github.com/chiazo/big-two)

The typescript version of my all time favorite card game, [Big Two](https://www.pagat.com/climbing/bigtwo.html). I was introduced to the game by my SummerBridge HK students in 2019 and I've been playing it ever since!

---

# [clothing-swap](https://chiazo.github.io/clothing-swap)

An algorithm that simulates clothing swaps among participants with different clothing sizes and item amounts indexing on fairness.

---

# [covid-stats](https://github.com/chiazo/covid-stats)

A manually run program designed to track and update COVID-19 trends in your city.

---
# [xChange](https://github.com/chiazo/xchange)

A UX/UI group project (COMP 590-093) built during my senior year to help UNC Chapel Hill students connect, share, and exchange resources in a private, campus-focused space.

[Click to see our demo!](https://chiazo.github.io/xchange/)

---

# [CSSG Education Team](https://cssg-edu-team.github.io/)

A course on React + Firebase I developed & taught during the Spring of 2021 as the UNC CS + Social Good Education Lead.

[Click to start learning!](https://cssg-edu-team.github.io/)

---

# [Team110](https://github.com/chiazo/team110)

A Gatsby site built from scratch to establish a central documentation hub for TAs of COMP110, the biggest CS course at UNC Chapel Hill.

[Click to see our written guides!](https://chiazo.github.io/team110/)

---


# [All Eyes on Us](https://github.com/chiazo/alleyesonus-demo)

A choose your own adventure web game for the Center for Court Innovation, a NYC-based non-profit, written in Twine. Built by hackNY fellows!

[Click to start your adventure.](https://youth-justice-board.github.io/AllEyesOnUs/)

---


# [FlexDJ](https://github.com/chiazo/FlexDJ-1)

A team project built for cross-platform playlist creation + more. FlexDJ merges Spotify, Youtube, and Deezer all in one place!

[Click to start making playlists.](https://flexdj.vercel.app/)

---

# [my-planner](https://github.com/chiazo/my-planner)

A web app that creates a daily schedule based on inputed tasks and their estimated time for completion + any blocks of free time I designate.

[Click to start planning!](https://chiazo.github.io/my-planner/)

---

# [readLearn](https://github.com/chiazo/read-learn)

A web app that takes in a text in another language, allowing the user to click words they don't know. Outputs a list of words to study later!

[Click to start reading.](https://chiazo.github.io/read-learn)

---

# [WordAdder](https://github.com/chiazo/word-adder)

A program to update foreign vocab lists hosted on google sheets with definitions & example sentences.

[Click to see the repo](https://github.com/chiazo/word-adder).

---

# [Eisenhower Matrix](https://github.com/chiazo/eisenhower-matrix)

A scheduling app using Google Cal API, Java Servlets, JS + Bootstrap! Built during Google Software Product Sprint.

[Click to see our code!](https://github.com/chiazo/eisenhower-matrix)


`;

export default code;
